import { ROLE_IDS } from '@/auth/utils'

export default [
  {
    path: '/position',
    name: 'position',
    component: () => import('@/views/pages/master-data/position/List.vue'),
    meta: {
      name: 'Posisi',
      resource: 'Management - Posisi',
      action: 'manage',
      allowedRoles: [ROLE_IDS.ADMIN],
    },
  },
]
